<div class="modal-header">
    <h4 class="modal-title">Configuración</h4>
    <button type="button" class="btn-close" (click)="closeDialog()"></button>
</div>
<div class="modal-body">
    <mat-dialog-content class="mat-typography">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <p>Defina las columnas que se permitirán modificar durante la solicitud de aprobación.</p>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Buscar</mat-label>
                    <input matInput [formControl]="searchControl" placeholder="Escribe para filtrar...">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <div class="attributes-container">
            <mat-checkbox 
                [checked]="areAllVisibleSelected()"
                [indeterminate]="isSomeVisibleSelected()"
                (change)="toggleSelectAllVisible($event)">Columnas
            </mat-checkbox> 
            <mat-divider></mat-divider>
            <div *ngFor="let attr of filteredAttributes; let i = index">
                <mat-checkbox [(ngModel)]="attr.selected">
                    {{ attr.name }}
                </mat-checkbox>
            </div>
            <div *ngIf="filteredAttributes.length === 0" class="text-center text-muted mt-3">
                No se encontraron atributos.
            </div>
        </div>
    </div>
   </mat-dialog-content>
</div>


<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar<mat-icon>close</mat-icon></button>
    <button mat-raised-button color="primary" (click)="onSave()">Guardar</button>
</mat-dialog-actions>